import * as React from 'react';


export default class UserContract extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
        <mask id="mask0_0_2349" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="6" y="1" width="4" height="6">
          <path fillRule="evenodd" clipRule="evenodd" d="M8.504 4.04309C8.44229 5.81337 5.88571 6.43052 7.34514 6.43052C8.80686 6.43052 9.98971 5.24766 9.98971 3.78709C9.98971 2.32766 8.80686 1.14252 7.34514 1.14252C5.88571 1.14252 8.59543 1.38366 8.504 4.04309Z" fill="white" />
        </mask>
        <g mask="url(#mask0_0_2349)">
          <path opacity="0.01" fillRule="evenodd" clipRule="evenodd" d="M1.18172 12.1448H15.704V-4.57178H1.18172V12.1448Z" fill="#2DB6E9" />
        </g>
        <path fillRule="evenodd" clipRule="evenodd" d="M9.78423 3.78653C9.78423 5.38196 8.49052 6.67453 6.89623 6.67453C5.29966 6.67453 4.00709 5.38196 4.00709 3.78653C4.00709 2.1911 5.29966 0.898529 6.89623 0.898529C8.49052 0.898529 9.78423 2.1911 9.78423 3.78653Z" stroke="#727272" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.6626 8.2352C9.69806 7.27177 8.36663 6.6752 6.89577 6.6752C4.0112 6.6752 1.66263 8.96777 1.5712 11.8295C1.56892 11.9232 1.64663 12.0021 1.74034 12.0021H7.59977" stroke="#727272" strokeLinecap="round" strokeLinejoin="round" />
        <path fillRule="evenodd" clipRule="evenodd" d="M7.64686 15.2454H13.9486V8.41452H7.64686V15.2454Z" stroke="#727272" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.5856 10.4373H12.0085" stroke="#727272" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.5856 12.4797H11.1387" stroke="#727272" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    )
  }
}
